import React from 'react';

import classNames from '../../utils/classNames';
import withInput from './withInput';

export const Radios = withInput(({ data, name, vertical, className, ...rest }) => {
  return (
    <div className={classNames('Form__Radio', vertical && 'Form__Radio--vertical', className)} {...rest}>
      {data.map((value, i) => (
        <div className="Form__Radio__Option" key={i}>
          <input type="radio" name={name} value={value.value ? value.value : value} id={`${name}__${i}`} defaultChecked={value.checked} /> 
          <label htmlFor={`${name}__${i}`}>{value.label ? value.label : value}</label>
        </div>
      ))}
    </div>
  )
});
